const clinicType = 'vet';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const pricingDetails = {
    vet: {
        Free: {
            accountType: 'Free',
            productId: isProd ? 'prod_Tq6n6ANYRZntEl' : 'prod_TkV4mmkNftnrtY',
            priceMonthlyId: isProd ? 'price_1SsQZuL2Uy8HcDMuz0gRrBtr' : 'price_1Sn04TL2Uy8HcDMuN0i4oiAa',
            priceMonthly: 0,
            priceAnnually: 0,
            priceAnnuallyId: isProd ? 'price_1SsQZuL2Uy8HcDMumI9bnFT4' : 'price_1Sn04TL2Uy8HcDMuBEO4PD0r',
            description: 'Supports both professionals in practice and student with their veterinary studies.',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'View interactive 3D models',
                'Ability to edit and annotate handouts',
                'Basic customer support',
            ],
            klaviyoListId: 'XXjqFu',
        },
        Student: {
            accountType: 'Student',
            productId: isProd ? 'prod_QjtOG8QIilyVNr' : 'prod_QXpfPHjuwthNx7',
            priceMonthlyId: isProd ? 'price_1R3uGcL2Uy8HcDMu9sPsymmb' : 'price_1QpDdKL2Uy8HcDMukMb7it5E',
            priceMonthly: 4.99,
            priceAnnually: 56.88,
            priceAnnuallyId: isProd ? 'price_1SLghQL2Uy8HcDMuHQlTrQiR' : 'price_1SLgf9L2Uy8HcDMuRiEDhFFz',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Basic customer support',
                'Interactive whiteboard',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'R2gDZ3',
            legacy: true, // Mark as legacy - hidden from new signups
        },
        Professional: {
            accountType: 'Professional',
            productId: isProd ? 'prod_QjtJiFdck0KupJ' : 'prod_QXpfh4Pw3WYGiz',
            priceMonthlyId: isProd ? 'price_1R3uJmL2Uy8HcDMu38y3aLAB' : 'price_1QpDg3L2Uy8HcDMubCIaJMFf',
            priceMonthly: 9.99,
            priceAnnually: 113.88,
            priceAnnuallyId: isProd ? 'price_1R3uK8L2Uy8HcDMupfKXnrP0' : 'price_1QpDjqL2Uy8HcDMuGAM33XUk',
            description: 'Ideal for individual vets, single clinic practices, and small business owners.',
            benefits: [
                '**Includes all Free features, plus:**',
                'Unlimited sharing, printing and saving',
                'Personal workspace',
                'Clinic name on all handouts',
                'Premium customer support',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'Y7kVFz',
        },
        Clinic: {
            accountType: 'Clinic',
            productId: isProd ? 'prod_QjtOpkXwFHjj9x' : 'prod_QXpg8C1N3zC1Xg',
            priceMonthlyId: isProd ? 'price_1R3u6TL2Uy8HcDMuA7XRseGI' : 'price_1QpDiAL2Uy8HcDMuWBw3FHhr',
            priceMonthly: 49.99,
            priceAnnually: 569.88,
            priceAnnuallyId: isProd ? 'price_1R3u7kL2Uy8HcDMuVn3RkcmJ' : 'price_1QpDiaL2Uy8HcDMu9yaaG4ZW',
            description: 'All-in-one plan that allows practices to manage teams and enhance client care.',
            benefits: [
                '**Includes all Pro pan features, plus:**',
                'Multi user access - up to 5 users',
                'Clinic logo on all handouts',
                'Clinic workspace',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'SDs2NJ',
        },
    },
};

module.exports = pricingDetails[clinicType];
